import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "../Utils/Utils.css";
import { getAccessToken } from "../Utils/Utils.js";

function sendSpecificResetPasswordRequest(mail, pw, pwc, t) {
  const url =
    process.env.REACT_APP_SOPHYAPP_API_URL +
    `/de/react/${getAccessToken()}/account/reset_specific_password`;
  var params = new FormData();
  params.append("email", mail);
  params.append("pw", pw);
  params.append("pwc", pwc);
  axios
    .post(url, params)
    .then(function () {
      alert(t("admin.passwordReset.success"));
    })
    .catch(function () {
      alert(t("admin.passwordReset.error"));
    });
}

function PasswordResetPopupModal(props) {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else if (password !== passwordConfirm) {
      alert("Passwords do not match");
      return;
    } else {
      sendSpecificResetPasswordRequest(
        props.user.email,
        password,
        passwordConfirm,
        t
      );
      props.onHide();
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <span>
              {t("admin.passwordReset.titlePrefix")}{" "}
              <strong>{props.user && props.user.email}</strong>
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>{t("admin.passwordReset.newPassword")}</Form.Label>
            <Form.Control
              type="password"
              placeholder="New Password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
            <Form.Label>{t("admin.common.confirmPassword")}</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm Password"
              required
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("admin.passwordReset.submit")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default PasswordResetPopupModal;
